import React, { Component } from 'react';
import PermissionsRole from './PermissionsRole';
import { getRoles, getPermissions, getRolesPermissions, setPermission } from './PermissionsRole.actions';
import Store from '../../../redux/Store';
import { showSnackbar } from '../../../common/state/snackbar/Snackbar.actions';
import Constants from '../../../common/constants/Constants';

class PermissionsRoleContainer extends Component {
  constructor() {
    super();

    this.state = {
      rols: [],
      permissions: [],
      rolePermissions: []
    };
    
    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    Promise.all([getRoles(), getPermissions(), getRolesPermissions()]).then(allResp => {
      let rolePermissionsMatrix = [];

      allResp[2].body.forEach(rolePermission => {
        if (!rolePermissionsMatrix[rolePermission.RoleId]) {
          rolePermissionsMatrix[rolePermission.RoleId] = {};
        }
        rolePermissionsMatrix[rolePermission.RoleId][rolePermission.PermissionId] = 1;
      });

      this.setState({
        rols: allResp[0].body,
        permissions: allResp[1].body,
        rolePermissions: rolePermissionsMatrix
      });
    });
  }

  render() {
    return (
      <PermissionsRole
        state={this.state}
        rols={this.state.rols}
        permissions={this.state.permissions}
        rolePermissions={this.state.rolePermissions}
        onChange={this._onChange}
      />
    );
  }

  _onChange = (role, permission) => {
    setPermission(permission.Value, role.RoleEntityId)
      .then((res) => {
        this._showSuccesMessage("Permission set successfully.");
        this._changeStatusPermission(role.RoleEntityId, permission.Value);
      })
      .catch((err) => {
        this._showFailMessage("Failed to set permission.")
      });
  }

  _changeStatusPermission(role, permission)
  {
  if(this.state.rolePermissions[role][permission])
    {
      let newState = this.state.rolePermissions;
      delete newState[role][permission];

      this.setState({
        rolePermissions: newState
      });
    }
    else
    {
      let newState = this.state.rolePermissions;
      newState[role][permission] = 1;

      this.setState({
        rolePermissions: newState
      });
    }
  }

  _showSuccesMessage(theMessage) {
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
        message: theMessage,
      })
    );
  }

  _showFailMessage(theMessage) {
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
        message: theMessage,
      })
    );
  }
}

export default PermissionsRoleContainer;
